import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AppError} from '@interface/app.error';
import {HeaderStep} from '@enum/header.step';
import {HeaderService} from '@service/header/header.service';
import {CommonService} from '@service/common/common.service';
import {AcademyService} from '@service/academy/academy.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-model-detail',
    templateUrl: './model-detail.component.html',
    styleUrls: ['./model-detail.component.scss'],
    standalone: false
})
export class ModelDetailComponent implements OnInit, OnDestroy {
  @Input() products: any;
  @Input() openedViaModelList = false;
  private destroy$ = new Subject();
  public product: any = {};
  public errors: AppError[] | undefined = [];
  public productId: string | undefined;
  public categoryId: string | undefined;
  public loadedCarouselImages = 1;

  constructor(private activatedRoute: ActivatedRoute,
              private headerService: HeaderService,
              private common: CommonService, private academy: AcademyService) {
  }

  ngOnInit(): void {
    this.headerService.header.next(HeaderStep.MODEL);
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params: any) => {
      if (params?.id) {
        this.productId = params?.id;
      }
      if (params?.categoryId) {
        this.categoryId = params?.categoryId;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  public convertProductImage(product: any, skip?: boolean): void {
    this.common.convertProductImage(product, skip);
  }

  public extractProductImage(event: any): void {
    this.academy.getModelImages(event?.images).then((images: any[]) => {
      this.product.images = images;
    });
  }

  changeCarousel(index: number): void {
    this.loadedCarouselImages = Math.max(this.loadedCarouselImages, index + 1);
  }
}
